import React, { useState } from 'react';
import { getEstimatedDeliveryDate } from '../services/shippingService';
import './DeliveryChecker.css';

const DeliveryChecker = () => {
  const [pincode, setPincode] = useState('');
  const [deliveryDate, setDeliveryDate] = useState('');
  const [error, setError] = useState('');

  const handleCheckDelivery = async () => {
    try {
      const response = await getEstimatedDeliveryDate(pincode);
      setDeliveryDate(response.delivery_date);
      setError('');
    } catch (err) {
      setDeliveryDate('');
      setError('Could not fetch delivery date for this pincode.');
    }
  };

  return (
    <div className="delivery-checker">
      <h2>Check Delivery Date</h2>
      <input
        type="text"
        value={pincode}
        onChange={(e) => setPincode(e.target.value)}
        placeholder="Enter pincode"
      />
      <button onClick={handleCheckDelivery}>Check</button>
      {deliveryDate && <p>Estimated delivery date: {deliveryDate}</p>}
      {error && <p>{error}</p>}
    </div>
  );
};

export default DeliveryChecker;